import React from "react";
import { Box, Stack, Typography } from "@mui/material";

interface SectionCardProps {
  title: string;
  description?: string;
  /** Optional element rendered on the right side of the header (e.g. counter, chip). */
  headerAction?: React.ReactNode;
  /** When false, the inner white card wrapper is omitted (children rendered directly). */
  withInnerCard?: boolean;
  /** Optional id — used by the preview pane scrollspy. */
  id?: string;
  children: React.ReactNode;
}

/**
 * Section wrapper used by every form section.
 */
const SectionCard: React.FC<SectionCardProps> = ({
  title,
  description,
  headerAction,
  withInnerCard = true,
  id,
  children,
}) => (
  <Stack
    component="section"
    id={id}
    direction="column"
    gap={5}
    p={3}
    sx={{
      bgcolor: (theme) => (theme.palette as any).grayscale?.[50] ?? "#F6F7F8",
      borderRadius: 3,
    }}
  >
    <Box
      sx={{
        px: 1,
        pt: 2,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box>
        <Typography variant="subtitle2">{title}</Typography>
        {description && (
          <Typography variant="caption" color="text.secondary">
            {description}
          </Typography>
        )}
      </Box>
      {headerAction}
    </Box>

    {withInnerCard ? (
      <Stack
        direction="column"
        gap={5}
        p={6}
        borderRadius={3}
        bgcolor="background.paper"
        sx={{
          border: "1px solid",
          borderColor: (theme) => (theme.palette as any).grayscale?.[100] ?? "#EAECEF",
        }}
      >
        {children}
      </Stack>
    ) : (
      <Stack direction="column" gap={5}>
        {children}
      </Stack>
    )}
  </Stack>
);

export default SectionCard;
